import { render, staticRenderFns } from "./FileUploadBox.vue?vue&type=template&id=3a0512c5&scoped=true&"
import script from "./FileUploadBox.vue?vue&type=script&lang=js&"
export * from "./FileUploadBox.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadBox.vue?vue&type=style&index=0&id=3a0512c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0512c5",
  null
  
)

export default component.exports